module.exports = __webpack_public_path__ + "static/media/Brands_19.5c036489.png";